<template>
<div class="vocabulary">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
        <el-breadcrumb-item>欢迎/结束语</el-breadcrumb-item>
    </el-breadcrumb>
    <div id="vocabularyContent">
        <p class="title">默认欢迎语</p>
        <div class="defaultWords">{{sys_welcom_word}}</div>
        <p class="title title2">默认结束语</p>
        <div class="defaultWords">{{sys_end_word}}</div>
        <div class="welcoming">
            <p class="title title2">
                自定义欢迎语（可选）<el-tooltip content="开发者可自定义用户进入技能后的欢迎语" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon"></i>
            </el-tooltip>
            </p>
            <div style="padding:0 80px 0 30px">
                <el-input id="input3" placeholder="请输入结束语，回车可添加" v-model="welcom_word" @keyup.enter.native="add_words('welcom')" :disabled="local"></el-input>
                <el-button type="primary" @click="add_words('welcom')" :disabled="local"><i class="el-icon-plus"></i> 添加</el-button>
                <ul class="form-group oftenInfo_table" style="margin-top:10px;">
                    <li class="list-group-item" v-for="(welcom, index) in welcomingList">
                        <div class="oftenInfo_title">
                <span>
                    {{welcom.text}}
                </span>
                            <i class="el-icon-circle-close deleteIcon pull-right"
                               style="margin-top:12px;" @click="remove_words('welcom', index, welcom.id)" v-if="!local"></i>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
      <div class="endWords">
          <p class="title">
              自定义结束语（可选）<el-tooltip content="开发者可自定义用户进入技能后的结束语" placement="top">
              <i class="icon iconfont icon-wenhao blurIcon"></i>
          </el-tooltip>
          </p>
          <div style="padding:0 80px 0 30px">
              <el-input id="input3" placeholder="请输入结束语，回车可添加" @keyup.enter.native="add_words('end')" v-model="end_word" :disabled="local"></el-input>
              <el-button type="primary" @click="add_words('end')" :disabled="local"><i class="el-icon-plus"></i> 添加</el-button>
              <ul class="form-group oftenInfo_table" style="margin-top:10px;">
                  <li class="list-group-item" v-for="(word, index) in endWords">
                      <div class="oftenInfo_title">
                <span>
                    {{word.text}}
                </span>
                          <i class="el-icon-circle-close deleteIcon pull-right"
                             style="margin-top:12px;" @click="remove_words('end', index, word.id)" v-if="!local"></i>
                      </div>
                  </li>
              </ul>
          </div>
      </div>

    </div>
</div>
</template>

<script>
    import qs from 'qs'
    import {getWords, addWords, removeWords} from '@/api'
    export default {
        name: "Vocabulary",
        data () {
            return {
                skill_id: this.$route.query.skillId,
                online: '',
                sys_welcom_word: '欢迎进入【技能名称】',
                sys_end_word: '【技能名称】已退出',
                welcom_word: '',
                end_word: '',
                welcomingList: [{id:1, text: '欢迎来到动物王国'}],
                endWords: [{id:1, text: '动物王国拜拜'}],
                local: false
            }
        },
        created () {
            this.get_words()
            this.isCanInput()
        },
        methods: {
            isCanInput() {
                if (localStorage.getItem('onlineFlag') == '1') {
                    this.local = true;
                } else {
                    this.local = false;
                }
            },
            // 添加欢迎语
            async add_words (type) {
                let data = {
                    'start': [],
                    'end': []
                }
                // let reg =  new RegExp("^[\u4e00-\u9fa5]+$")
                console.log(type)
                if (type == 'welcom') {
                    if (!this.welcom_word) {
                        this.$message.error('欢迎语不能为空')
                        return
                    }
                    // else if (!reg.test(this.welcom_word)) {
                    //     this.$message.error('仅支持汉字输入')
                    //     return
                    // }
                    data.start.push(this.welcom_word)
                    this.welcom_word = ''
                } else if (type == 'end') {
                    if (!this.end_word) {
                        this.$message.error('结束语不能为空')
                        return
                    }
                    // else if (!reg.test(this.end_word)) {
                    //     this.$message.error('仅支持汉字输入')
                    //     return
                    // }
                    data.end.push(this.end_word)
                    this.end_word = ''
                } else {
                    return
                }
                let res = await addWords(this.skill_id, qs.stringify(data))
                if (res.data.code == 200) {
                    this.$message({message: '添加自定义语句成功', type: 'success'})
                    this.get_words()
                } else {
                    this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
                }

            },
            // 删除欢迎语结束语
            async remove_words (type, index, id) {
                this.$confirm('是否删除此自定义语句?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    removeWords(this.skill_id, id).then((res) => {
                        if (res.data.code == 200) {
                            if (type == 'welcom') {
                                this.welcomingList.splice(index, 1)
                            } else if (type == 'end') {
                                this.endWords.splice(index, 1)
                            } else {
                                return
                            }
                            this.$message.success('删除成功')
                        } else {
                            this.$message.success('删除失败')
                        }
                    }).catch((error) => {
                        console.log(error)
                    })
                }).catch(() => {})
            },
            
            // 获取欢迎语结束语的信息
            async get_words () {
                let res = await getWords(this.skill_id)
                if (res.data.code == 200) {
                    this.sys_welcom_word = res.data.data.sys.start[0].text
                    this.sys_end_word = res.data.data.sys.end[0].text
                    this.welcomingList = res.data.data.user.start || []
                    this.endWords = res.data.data.user.end || []

                } else {
                    this.$message({message: '当前网络状况异常，请稍后再试', type: 'error'})
                }
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    #vocabularyContent {
        background: #fff;
        padding-bottom:30px;
        .title {
            height: 64px;
            line-height: 64px;
            padding-left: 30px;
            font-size: 16px;
            font-weight: 800;
            color: #2e4d79;
            margin-bottom: 30px;
            border-bottom: 1px solid #f5f5f5;
            border-left: 2px solid #010202;
            .icon-wenhao{
                cursor: pointer;
                font-weight: normal;
            }
            .blurIcon {
                color: #7abaf1;
            }
        }
        .title2 {
            border-top: 1px solid #f5f5f5;
        }
        .defaultWords{
            padding:0 30px 30px 50px;
            font-size:14px;
            color:#5e5e5e;
        }
        .welcoming,.endWords {
            background: #fff;
            .el-input {
                width: 500px;
            }
            #input3 {
                width: 100%;
            }
            ul {
                li {
                    padding: 0;
                    .oftenInfo_title {
                        line-height: 46px;
                        color: #4f4f4f;
                        font-size: 14px;
                        padding: 0 20px;
                        word-wrap:break-word
                    }
                    .deleteIcon {
                        font-size: 20px;
                        color: #ccc;
                    }
                    .deleteIcon:hover {
                        color: #f56c6c;
                    }

                }
            }

            button {
                margin-left:10px;
                height: 35px;
                position: relative;
                top: 3px;
                span {
                    position: relative;
                    top: -3px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/skill/Vocabulary.vue